import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export interface PaginationState {
  page: number;
  rowsPerPage: number;
  skip: number;
}

export interface PaginationContextResult {
  pagination: PaginationState;
  setPagination: Dispatch<SetStateAction<PaginationState>>;
}

export interface PaginationProviderProps {
  defaultPagination?: PaginationState;
}

export const DEFAULT_STATE: PaginationState = {
  page: 0,
  rowsPerPage: 10,
  skip: 0,
};

const PaginationContext = createContext<PaginationContextResult>({
  pagination: DEFAULT_STATE,
  setPagination: () => {
    // void
  },
});

const PaginationProvider: FC<PropsWithChildren<PaginationProviderProps>> = ({
  children,
  defaultPagination = DEFAULT_STATE,
}) => {
  const [pagination, setPagination] = useState(defaultPagination);

  return (
    <PaginationContext.Provider value={{ pagination, setPagination }}>
      {children}
    </PaginationContext.Provider>
  );
};

export const usePaginationContext = (): PaginationContextResult => {
  const context = useContext(PaginationContext);

  if (!context) {
    throw new Error(
      'usePaginationContext must be used within a PaginationProvider'
    );
  }

  return context;
};

export default PaginationProvider;
